import { Exclude, Expose } from 'class-transformer';

import { Avatar, IUserWithPartner } from '@core/models';


@Exclude()
export class UserWithPartner implements IUserWithPartner {
  @Expose()
    name!: string;

  @Expose()
    email!: string;

  @Expose()
    createdAt!: string;

  @Expose()
    registeredAt!: string;

  @Expose()
    id!: string;

  @Expose()
    avatar!: Avatar;

  @Expose()
    updatedAt!: string | null;
}
